module.exports = __webpack_public_path__ + "img/CWM-WebsiteTiles-EOTAS-F01-UnknownSoldier-72dpi.191b5eea.jpg";